'use strict';

var React = require('react');
var Form = require('plexus-form');
var validate = require('plexus-validate');

var generators = require('annogenerate');
var math = require('annomath');
var Paginator = require('react-pagify').default;
var pagifyBootstrapPreset = require('react-pagify-preset-bootstrap');
var titleCase = require('title-case');
var findIndex = require('lodash/findIndex');
var orderBy = require('lodash/orderBy');
var cx = require('classnames');
var segmentize = require('segmentize');

var Table = require('reactabular').Table;

var ColumnNames= require('reactabular').ColumnNames;

var Search = require('reactabular').Search;

var editors = require('reactabular').editors;

var sortColumn = require('reactabular').sortColumn;

var cells = require('reactabular').cells;

var ColumnFilters = require('./columnFilters.js');
var FieldWrapper = require('./fieldWrapper.js');
var SectionWrapper = require('./sectionWrapper.js');

var highlight = require('./formatters/highlight.js');

var Globalize = require('globalize');
var FormatMessage = require('react-globalize').FormatMessage;


module.exports = React.createClass({
    displayName: 'DataTable',
    getInitialState() {
      
        var data = [];
        data = attachIds(data);

        var highlighter = (column) => highlight((value) => {
            return Search.matches(column, value, this.state.search.query);
        });

        return {
            locale: this.props.locale,
            editedCell: null,
            data: data,
            search: {
                column: '',
                query: ''
            },
            header: {
                onClick: (column) => {
                    // reset edits
                    this.setState({
                        editedCell: null
                    });

                    sortColumn(
                        this.state.columns,
                        column,
                        this.setState.bind(this)
                    );
                },
                className: cx(['tblheader'])
            },
            sortingColumn: null, // reference to sorting column
              columns: [
                {
                    property: 'label',
                    header: Globalize(this.props.locale).messageFormatter(this.props.title)()
                },

            ],
            modal: {
                title: 'title',
                content: 'content',
            },
            pagination: {
                page: 1,
                perPage: 10
            }
        };
    },

    onSearch(search) {
        this.setState({
            editedCell: null, // reset edits
            search: search,
        });
    },

    columnFilters() {
        var headerConfig = this.state.header;
        var columns = this.state.columns;
        // if you don't want an header, just return;
        return (
            <thead>
                <ColumnNames config={headerConfig} columns={columns} />
            </thead>
        );
    },

    componentWillReceiveProps(nextProps) {
      this.setState({
        locale: nextProps.locale
      });
    },

    render() {
        this.state.locale = this.props.locale;


       this.state.columns = [
         {
           property: 'label',
           header: Globalize(this.props.locale).messageFormatter(this.props.title)()
         },

       ];
        var columns = this.state.columns;


        var pagination = this.state.pagination || {};

        this.state.data = this.props.data || [];


        var data = this.state.data || [];


        if (this.state.search.query) {
            data = Search.search(
                data,
                columns,
                this.state.search.column,
                this.state.search.query
            );
        }

        data = sortColumn.sort(data, this.state.sortingColumn, orderBy);

        var paginated = paginate(data, pagination);
        var pages = Math.ceil(data.length / Math.max(
          isNaN(pagination.perPage) ? 1 : pagination.perPage, 1)
        );

        return (

            <div>

                <div className='controls'>

                      <Search data={this.state.data} onChange={this.onSearch} />

                </div>
                <Table
                    className='table table-striped'
                    columnNames={this.columnFilters}
                    columns={columns}
                    data={paginated.data}
                    row={(d, rowIndex) => {
                        return {
                            className: rowIndex % 2 ? 'odd-row' : 'even-row',
                            onClick: () => console.log('clicked row', d)
                        };
                    }}
                >
                </Table>

               <div className='row'>

                    <div className='col-xs-12 controls'>
                      <div className='pagination list-unstyled'>
                          <Paginator.Context className="pagify-pagination"
                          {...pagifyBootstrapPreset}
                          segments={segmentize({
                              page: pagination.page,
                              pages: pages,
                              beginPages: 1,
                              endPages: 1,
                              sidePages: 1
                          })} onSelect={this.onSelect}>

                              <Paginator.Button page={pagination.page - 1}><FormatMessage locale={this.state.locale} path="buttons/bttn_previous" /></Paginator.Button>

                              <Paginator.Segment field="beginPages" />

                              <Paginator.Ellipsis className="ellipsis"
                                previousField="beginPages" nextField="previousPages" />

                              <Paginator.Segment field="previousPages" />

                              <Paginator.Segment field="centerPage" className="active" />

                              <Paginator.Segment field="nextPages" />


                              <Paginator.Ellipsis className="ellipsis"
                                previousField="nextPages" nextField="endPages" />

                              <Paginator.Segment field="endPages" />

                              <Paginator.Button page={pagination.page + 1}><FormatMessage locale={this.state.locale} path="buttons/bttn_next" /></Paginator.Button>

                              </Paginator.Context>
                      </div>
                    </div>

               </div>
            </div>
        );
    },

    onSelect(page, event) {
      event.preventDefault();

      const state = this.state;
      const pagination = state.pagination || {};
      const pages = Math.ceil(state.data.length / pagination.perPage);

      pagination.page = Math.min(Math.max(page, 1), pages);

        this.setState({
            pagination: pagination
        });
    },

    onPerPage(e) {
        var pagination = this.state.pagination || {};

        pagination.perPage = parseInt(e.target.value, 10);

        this.setState({
            pagination: pagination
        });
    },
});

function paginate(data, o) {

    data = data || [];

    // adapt to zero indexed logic
    var page = o.page - 1 || 0;
    var perPage = o.perPage;

    var amountOfPages = Math.ceil(data.length / perPage);
    var startPage = page < amountOfPages? page: 0;
    return {
        amount: amountOfPages,
        data: data.slice(startPage * perPage, startPage * perPage + perPage),
        page: startPage
    };
}

function augmentWithTitles(o) {
    for (var property in o) {
        o[property].title = titleCase(property);
    }

    return o;
}


function attachIds(arr) {
    return arr.map((o, i) => {
        o.id = i;

        return o;
    });
}

function find(arr, key, value) {
    return arr.reduce((a, b) => a[key] === value ? a : b[key] === value && b);
}



// WEBPACK FOOTER //
// ./js/table.js